import { inject, injectable } from 'inversify';
import OrdersRepository from 'src/features/orders/data/OrdersRepository';
import { CreateOrderParams } from 'src/features/orders/data/service/OrdersService.types';
import { PaymentMethodSlug } from 'src/types/common';

export interface CreateClipOrderUseCaseParams
  extends Omit<CreateOrderParams, 'payment_method'> {}

@injectable()
class CreateClipOrderUseCase {
  @inject(OrdersRepository) private ordersRepository!: OrdersRepository;

  async execute(params: CreateClipOrderUseCaseParams) {
    return await this.ordersRepository.createOrder({
      ...params,
      payment_method: PaymentMethodSlug.Clip,
    });
  }
}

export default CreateClipOrderUseCase;
